// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/taxiing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/taxiing/taxiing.js';

mount([g0]);
